// extracted by mini-css-extract-plugin
export default {"container":"qk-z","blurb":"rk-z","links":"sk-z"};